import { HttpErrorResponse } from '@angular/common/http';

export type SubmissionErrorKind = 'invalid' | 'forbidden' | 'notFound' | 'conflict' | 'tooLarge' | 'unknown';

const STATUS_TO_KIND: Record<number, SubmissionErrorKind> = {
    400: 'invalid',
    403: 'forbidden',
    404: 'notFound',
    409: 'conflict',
    413: 'tooLarge'
};

export function submissionErrorKind(error: unknown): SubmissionErrorKind {
    if (error instanceof HttpErrorResponse) {
        return STATUS_TO_KIND[error.status] ?? 'unknown';
    }
    return 'unknown';
}
